import * as React from "react";

interface VimeoProps {
    videoId: string;
    frameId: string;
    autoplay?: boolean;
    onFinish?(): void;
}

export class Vimeo extends React.Component<VimeoProps, {}> {

    render() {
        return (
            <div className="video-vimeo-container">
                <iframe id={this.props.frameId} src={this.getVimeoUrl()} width="600" height="340"
                        frameBorder="0" allowFullScreen>
                </iframe>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.onFinish) {
            let vimeoIFrame: Element = document.getElementById(this.props.frameId);
            let vimeoPlayer = $f(vimeoIFrame);
            vimeoPlayer.addEvent('ready', () => {
                vimeoPlayer.addEvent('finish', this.props.onFinish);
            });
        }
    }

    private getVimeoUrl() {
        return `https://player.vimeo.com/video/${this.props.videoId}${this.props.autoplay ? '?autoplay=1&dnt=1' : '?dnt=1'}`;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/Vimeo.tsx
 **/